import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';

import i18next from '../../translations/i18n';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
    window.newrelic.noticeError(error);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <>
          <Card.Header>{i18next.t('ErrorHeading')}</Card.Header>
          <Card.Text>
            {i18next.t('PleaseReloadText')}{' '}
            <Button
              as="link"
              href={process.env.REACT_APP_CONTACT_US_URL}
              target="_blank"
              className=""
            >
              {i18next.t('ContactUs')}
            </Button>{' '}
            {i18next.t('ProblemPersists')}
          </Card.Text>
        </>
      );
    }
    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ErrorBoundary;
